module.exports = __webpack_public_path__ + "static/img/head_floor.445dfd10.jpg";